import { Routes, Route, useNavigate } from "react-router-dom";
import DashboardLayout from './containers/layouts/dashboard/dashboard';
import InvestorUpdates from './pages/dashboard/investor-updates';
import LatestNews from './pages/dashboard/latest-news';
import ProfileSetting from './pages/settings/profile';
import AccountSetting from './pages/settings/account';
import CaseLayout from "./containers/layouts/case/case";
import News from "./pages/case/news";
import LossReport from "./pages/case/loss-report";
import ClaimantDetails from "./pages/case/claimant-details";
import CaseInvestorUpdates from "./pages/case/investor-updates"
import SignIn from "./pages/auth/sign-in";
import AuthenticationLayout from "./containers/layouts/authentication/authentication";
import SignUp from "./pages/auth/sign-up";
import ClaimantDetailsViewFunds from "./pages/case/claimant-details-view-funds";
import ClaimantDetailsViewFiles from "./pages/case/claimant-details-view-files";
import ClaimantDetailsViewLayout from "./containers/layouts/claimant-details-view/claimant-details-view";
import SiteLayout from "./containers/layouts/Site/site";
import { useAuthentication } from "@myinnsworth/hooks/authenticationHook";
import { useEffect } from "react";
import ForgotPassword from "pages/auth/forgot-password";
import { AuthenticationState } from "@myinnsworth/contexts/AuthenticationContext";
import AuthenticationProvider from "@myinnsworth/providers/AuthenticationProvider";
import NewsDetails from "pages/case/news-details";
import ResetPassword from "pages/auth/reset-password";
import ConfirmSignUp from "pages/auth/confirm-sign-up";
import AppStoreProvider from "@myinnsworth/providers/AppStoreProvider";

function App() {
  const authentication = useAuthentication();
  const nav = useNavigate();

  useEffect(() => {
    if (authentication.state === AuthenticationState.SignedOut && !window.location.href.includes('auth/')) {
      nav('/auth/sign-in');
    }
  }, [authentication, nav]);

  return (<>
    <AuthenticationProvider>
      <AppStoreProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route index element={<DashboardLayout />} />

            <Route path='dashboard' element={<DashboardLayout />} >
              <Route index element={<LatestNews />} />
              <Route path='latest-news' element={<LatestNews />} />
              <Route path='latest-news/:id' element={<NewsDetails />} />
              <Route path='investor-updates' element={<InvestorUpdates />} />
            </Route>

            <Route path="cases" element={<CaseLayout />}>
              <Route path=":slug">
                <Route path="investor-updates" element={<CaseInvestorUpdates />} />
                <Route path="news" element={<News />} handle="case-news" />
                <Route path="news/:id" element={<NewsDetails />} />
                <Route path="loss-report" element={<LossReport />} />
                <Route path="claimant-details" element={<ClaimantDetails />} />
                <Route path="claimant-details/:institutionId/view" element={<ClaimantDetailsViewLayout />}>
                  <Route path="index" element={<LossReport />} />
                  <Route path="funds" element={<ClaimantDetailsViewFunds />} />
                  <Route path="files" element={<ClaimantDetailsViewFiles />} />
                  <Route path="funds/:fundId/view/index" element={<LossReport />} />
                  <Route path="funds/:fundId/view/files" element={<ClaimantDetailsViewFiles />} />
                </Route>
              </Route>
            </Route>

            <Route path='settings/profile' element={<ProfileSetting />} />
            <Route path='settings/account' element={<AccountSetting />} />
          </Route>
          <Route element={<AuthenticationLayout />}>
            <Route path="auth/sign-in" element={<SignIn />} />
            <Route path="auth/sign-up" element={<SignUp />} />
            <Route path="auth/sign-up/:token" element={<ConfirmSignUp />} />
            <Route path="auth/forgot-password" element={<ForgotPassword />} />
            <Route path="auth/reset-password/:token" element={<ResetPassword />} />
          </Route>
        </Routes>
      </AppStoreProvider>
    </AuthenticationProvider>
  </>);
}

export default App;
